import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '@features/auth/auth.store';
import { shouldSkipAuthorization } from './auth-endpoints';

export const JwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);
  const hasNoAuthHeader = req.headers.has('NO_AUTH');
  const sanitizedRequest = hasNoAuthHeader
    ? req.clone({ headers: req.headers.delete('NO_AUTH') })
    : req;

  if (hasNoAuthHeader || shouldSkipAuthorization(sanitizedRequest.url)) {
    return next(sanitizedRequest);
  }

  const accessToken = authStore.token();
  if (!accessToken) {
    return next(sanitizedRequest);
  }

  return next(sanitizedRequest.clone({
    setHeaders: {
      Authorization: `Bearer ${accessToken}`,
    },
  }));
};
